// extracted by mini-css-extract-plugin
export default {"wrapper":"Boost_wrapper__knrKO","modalClose":"Boost_modalClose__tkEYR"};